import {
	COMPANIES_UPDATE_SUCCESS,
	COMPANIES_UPDATE_FAIL,
	SHOW_CB_LOADER,
	HIDE_CB_LOADER
} from './actions';

const initialState = {
	loading: false
};

export default (state = initialState, action) => {
	switch (action.type) {

		case SHOW_CB_LOADER:
			return {
				...state,
				loading: true
			};

		case COMPANIES_UPDATE_FAIL:
		case COMPANIES_UPDATE_SUCCESS:
		case HIDE_CB_LOADER:
			return {
				...state,
				loading: false
			};

		default:
			return state;
	}

};

export const showChargebeeLoader = () => {
	return { type: SHOW_CB_LOADER };
};

export const hideChargebeeLoader = () => {
	return { type: HIDE_CB_LOADER };
};


// WEBPACK FOOTER //
// ./src/redux/modules/chargebeeLoader.js